import { render } from "./PasswordResetConfirmScreen.vue?vue&type=template&id=30b43e5f&scoped=true&ts=true&lang=pug"
import script from "./PasswordResetConfirmScreen.vue?vue&type=script&lang=ts"
export * from "./PasswordResetConfirmScreen.vue?vue&type=script&lang=ts"

import "./PasswordResetConfirmScreen.vue?vue&type=style&index=0&id=30b43e5f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b43e5f"]])

export default __exports__